/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2024, Zumper
 * @description   Short-term Rentals United bizos
 */

import { Bizo, autoclass } from './base'
import type {
  RawRentalsUnitedAvailability,
  RawRentalsUnitedPriceInfo,
  RentalsUnitedAvailability as RentalsUnitedAvailabilityType,
  RentalsUnitedPriceInfo as RentalsUnitedPriceInfoType,
} from './rentalsUnitedAvailability.types'

export const RentalsUnitedPriceInfo: typeof RentalsUnitedPriceInfoType = autoclass<
  RentalsUnitedPriceInfoType,
  RawRentalsUnitedPriceInfo
>(
  'RentalsUnitedPriceInfo',
  class RentalsUnitedPriceInfo extends Bizo<
    RentalsUnitedPriceInfoType,
    RawRentalsUnitedPriceInfo
  > {},
  {
    createdOn: 'created_on',
    currency: 'currency',
    deposit: 'deposit',
    endDate: 'end_date',
    externalLink: 'external_link',
    /** Fee for reserving a listing in dollars */
    fee: 'fee_amount',
    isAvailable: 'is_available',
    listingId: 'listing_id',
    maxGuests: 'guests',
    maxLength: 'max_length_of_stay',
    minLength: 'min_length_of_stay',
    modifiedOn: 'modified_on',
    reservations: 'reservations',
    shortTermAvailabilityId: 'short_term_availability_id',
    startDate: 'start_date',
    status: 'status',
    totalPrice: 'total_amount',
    userId: 'userId',
    price: 'price',
  }
)

export type RentalsUnitedPriceInfo = RentalsUnitedPriceInfoType

export const RentalsUnitedAvailability: typeof RentalsUnitedAvailabilityType = autoclass<
  RentalsUnitedAvailabilityType,
  RawRentalsUnitedAvailability
>(
  'RentalsUnitedAvailability',
  class RentalsUnitedAvailability extends Bizo<
    RentalsUnitedAvailabilityType,
    RawRentalsUnitedAvailability
  > {},
  {
    prices: { name: 'prices', type: RentalsUnitedPriceInfo },
  }
)

export type RentalsUnitedAvailability = RentalsUnitedAvailabilityType
